module.exports = __webpack_public_path__ + "img/logo_info.ad9ba2aa.svg";